import { HttpClient, HttpContext, HttpParams, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { SHOW_GLOBAL_LOADER } from '@shared/data-access/data-access-ui';
import { Observable } from 'rxjs';

import { CompromisedCard, MonitoredBin, PaginatedResponse } from '../model/compromised-card.model';
import { CompromisedCardFilters, FilterCompromisedCardRequest } from '../model/compromised-card-filter-request.model';

@Injectable()
export class BankCardService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiUrl;

  getCards(payload: FilterCompromisedCardRequest): Observable<PaginatedResponse<CompromisedCard>> {
    const params = this.filterParams(payload).set('pageNumber', payload.pageNumber).set('pageSize', payload.pageSize);

    return this.http.get<PaginatedResponse<CompromisedCard>>(`${this.baseUrl}/v1/bankcards/cards`, {
      params,
      context: new HttpContext().set(SHOW_GLOBAL_LOADER, payload.enableGlobalLoader),
    });
  }

  getMonitoredBins(): Observable<MonitoredBin[]> {
    return this.http.get<MonitoredBin[]>(`${this.baseUrl}/v1/bankcards/monitored-bins`);
  }

  /** The PDF contains every card matching the filters, not only the page on screen. */
  downloadReportPdf(filters: CompromisedCardFilters): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.baseUrl}/v1/bankcards/cards/report/pdf`, {
      params: this.filterParams(filters),
      responseType: 'blob',
      observe: 'response',
      context: new HttpContext().set(SHOW_GLOBAL_LOADER, true),
    });
  }

  private filterParams(filters: CompromisedCardFilters): HttpParams {
    let params = new HttpParams().set('orderBy', filters.orderBy).set('sortDirection', filters.sortDirection);

    if (filters.bin) {
      params = params.set('bin', filters.bin);
    }

    if (filters.search) {
      params = params.set('search', filters.search);
    }

    if (filters.dateFrom) {
      params = params.set('dateFrom', filters.dateFrom);
    }

    if (filters.dateTo) {
      params = params.set('dateTo', filters.dateTo);
    }

    return params;
  }
}
